import { useScopedAppFlagStore } from '@frontend/scope';
import { useGetSchedulerV3FeatureFlagDetails } from './use-get-scheduler-v3-feature-flag-details';

export const useGetScheduleDefinitionsFeatureFlagDetails = () => {
  const { isScheduleV3FlagEnabled, isLoading } = useGetSchedulerV3FeatureFlagDetails();

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasScheduleDefinitions = getFeatureFlagValue('schedule-definitions', 'ALL');

  return {
    isScheduleDefinitionsEnabled: isLoading ? false : hasScheduleDefinitions && isScheduleV3FlagEnabled,
    isLoading,
  };
};
